<template>
  <div class="tools-table-events d-flex align-items-center">
    <span v-if="permissions.length === 1" class="fs-12">
      {{ permissions[0] }}
    </span>

    <bp-events-popper
      v-else-if="permissions.length > 1"
      :options="popperOptions"
      class="permissions-popper"
    >
      <div class="permissions-container" slot="reference">
        <span>
          {{ permissions.join(",  ") }}
        </span>
      </div>

      <div class="bp-permissions-popper-body">
        <div v-for="(permission, i) in permissions" :key="i">
          {{ permission }}
        </div>
      </div>
    </bp-events-popper>
  </div>
</template>

<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  components: { "bp-events-popper": Popper },
  props: {
    permissions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      popperOptions: {
        placement: "right",
        modifiers: {
          offset: { offset: "0,10px" },
          flip: { enable: true }
        }
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.tools-table-events {
  .permissions-popper {
    width: 100%;
    @media screen and (max-width: 991px) {
      max-width: 150px;
    }
  }
  .permissions-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    overflow: hidden;
    span {
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .bp-permissions-popper-body {
    z-index: 99999999;
    padding: 4px 8px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;

    background: var(--dark-80);
    color: var(--light);
    font-size: 12px;
  }
}
</style>
